import Vue from "vue";
import VueRouter from "vue-router";

import Inicio from "./components/Inicio.vue";
import Juridica from "./components/Juridica.vue";
import Fisica from "./components/Fisica.vue";
import Cliente from "./components/Cliente.vue";
import Informacion from "./components/Informacion.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/juridica/:id",
    name: "juridica",
    component: Juridica,
  },
  {
    path: "/fisica/:id",
    name: "fisica",
    component: Fisica,
  },
  {
    path: "/cliente/:id",
    name: "cliente",
    component: Cliente,
  },
  {
    path: "/",
    name: "inicio",
    component: Inicio,
  },
  {
    path: "/informacion",
    name: "informacion",
    component: Informacion,
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
